import {
  Box,
  Divider,
  Grid,
  IconButton,
  Step,
  StepContent,
  Typography,
} from "@mui/material";
import { DisplayOneNoteProps } from "../../Utils/Types";
import { ENoteType } from "../../Utils/Enums";
// import { Vocabulary } from "../../Utils/Vocabulary";
import { Delete } from "@mui/icons-material";
import styles from "../../Styles/note.module.css";
import { extractStringFromHtml, formatDate } from "../../Utils/Utils";
import { ONLINE_PAYMENT } from "../../Utils/Constants";

export default function DisplayOneNote(props: DisplayOneNoteProps) {
  const { note, handleDelete, disabled } = props;

  return (
    <div key={`${note.id}`}>
      <Step active={true}>
        <StepContent>
          <Box className={styles.displayOneNoteBox}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={12} style={{ display: "flex" }}>
                <Typography
                  style={{
                    padding: "2px",
                    fontStyle: "ITALIC",
                    color: "#1ab394",
                    fontWeight: "bold",
                  }}
                >
                  {note?.userName || ONLINE_PAYMENT}
                </Typography>
                <Typography style={{ padding: "2px 5px", fontStyle: "ITALIC" }}>
                  {formatDate(note?.createdAt, "dd.MM.yyyy HH:mm")}
                </Typography>
              </Grid>
              {/* <Grid
                item
                xs={8.3}
                md={8.3}
                lg={8.3}
                className={styles.displayOneNoteVisibleToClientChipGrid}
              >
                <span className={styles.displayOneNoteVisibleToClientChip}>
                  {note.visibility ? (
                    <Chip label={Vocabulary.visibleToClient} />
                  ) : null}
                </span>
              </Grid> */}
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  dangerouslySetInnerHTML={{ __html: note.messages }}
                />
              </Grid>

              {note.details && (
                <Grid item xs={12} md={12} lg={12}>
                  <Divider sx={{ margin: "10px 0px !important" }} />
                  <Typography>
                    {`${extractStringFromHtml(note.details || "").substring(
                      0,
                      300
                    )} ${note?.details?.length > 200 ? "..." : ""}`}
                  </Typography>
                </Grid>
              )}
            </Grid>

            <div className={styles.displayOneNoteButtons}>
              {note.type === ENoteType.OTHERS ? (
                <IconButton
                  disabled={disabled}
                  onClick={() => handleDelete(note)}
                >
                  <Delete style={{ cursor: "pointer" }} />
                </IconButton>
              ) : null}
            </div>
          </Box>
        </StepContent>
      </Step>
    </div>
  );
}
